import en from '../intl/en-US';
import cz from '../intl/cs-CZ';
import stringCompile from '../utils/stringCompile';

// type LangFile = { [key: string]: string };
type LangFiles = any;
// type LangFiles = {
//   "cs-CZ": LangFile;
//   "en-US": LangFile;
// };

export const langsApiObject: any = {
    CZ: 'cs-CZ',
    EN: 'en-US',
};

export const langsObjectMoment: { [key: string]: string } = {
    'cs-CZ': 'cs',
    'en-US': 'en',
};

const langsObject: any = {
    'cs-CZ': 'CZ',
    'en-US': 'EN',
};

const langKeysFiles: LangFiles = {
    'cs-CZ': cz,
    'en-US': en,
};

const locale: string =
    localStorage.getItem('language') ||
    (navigator.languages && navigator.languages[0]) ||
    navigator.language ||
    // navigator.userLanguage ||
    'en-US';

const lang = !!langKeysFiles[locale] ? locale : 'en-US';

if (localStorage.getItem('language') !== lang) {
    localStorage.setItem('language', lang);
}

export const getLang = () => {
    return lang;
};

export const getLangKey = (): 'EN' | 'CZ' => {
    return langsObject[lang] || 'EN';
};

const langKeysObject = langKeysFiles[lang] || langKeysFiles['en-US'];

const warnedMissingKeys = new Set<string>();

const translate = (id: string, params?: any) => {
    if (!langKeysObject[id] && !langKeysFiles['en-US'][id]) {
        if (process.env.NODE_ENV !== 'production' && !warnedMissingKeys.has(id)) {
            warnedMissingKeys.add(id);
            console.warn(`[intl] Missing translation key: ${id}`);
        }
        return id;
    }

    const text = langKeysObject[id] || langKeysFiles['en-US'][id] || '';

    if (params) {
        return stringCompile(text, params, id);
    }
    return text;
};

/** True when the key exists in the active locale or in the en-US fallback (no warning is logged). */
export const hasTranslation = (id: string): boolean => !!(langKeysObject[id] || langKeysFiles['en-US'][id]);

export default translate;
